
import { useCallback, useMemo } from 'react';


import { SET_FINETUNE } from '../actions';
import useStore from './useStore';

const useFinetune = (finetune, initialProps) => {
  const { dispatch, finetunesProps } = useStore();

  const setFinetuneWithProps = useCallback((newFinetuneProps) => {
    dispatch({
      type: SET_FINETUNE,
      payload: {
        finetune,
        finetuneProps: newFinetuneProps,
      },
    });
  }, []);

  const displayedFinetuneProps = useMemo(
    () => ({
      ...initialProps,
      ...finetunesProps,
    }),
    [finetunesProps, initialProps],
  );

  return useMemo(
    () => [displayedFinetuneProps, setFinetuneWithProps],
    [displayedFinetuneProps, setFinetuneWithProps],
  );
};

export default useFinetune;
